import MuiAccordionDetails, {
    AccordionDetailsProps,
} from '@mui/material/AccordionDetails';

import { withSxProp } from 'common/utils/props';

export const SimpleAccordionDetails = ({
    sx,
    ...other
}: AccordionDetailsProps) => (
    <MuiAccordionDetails
        sx={[
            { width: '100%', p: 0, pb: { xs: 2, sm: 3 }, mt: -2 },
            ...withSxProp(sx),
        ]}
        {...other}
    />
);
